import truncate from 'lodash/truncate';
import { dateTime } from '../../DateTime';
import { currency } from '../../Currency';

export const formatPrintEndorsementContent = (endorsement, { totalAmount, currencyCode, timeZoneOffset }, locale) => {
  const formattedEndorsement = `${endorsement}|${currency({ amount: totalAmount, code: currencyCode, locale })}|${dateTime({
    date: {
      time: new Date().getTime(),
      timeZoneOffset,
    },
    locale,
    showShortDateOfTime: true,
  })}`;
  return truncate(formattedEndorsement, {
    length: 100,
    omission: '',
  });
};
